import React, { useEffect, useCallback, useState } from 'react';
import { Grid } from 'components/Grid';
import { RowBetween } from 'components/Row';
import { MissionCenterContainer } from './styled';
import { UserMission } from 'gql-ops/graph/__generated__/request';
import { TYPE } from 'theme';
import missionStore from 'stores/missionStore';
import { ReactComponent as CloseSVG } from 'assets/images/home/mint-close.svg';
import { ReactComponent as BridgeSVG } from 'assets/images/home/bridge.svg';
import { ReactComponent as GoatupSVG } from 'assets/images/home/goatup.svg';
import { ReactComponent as SatoshiSVG } from 'assets/images/home/satoshi.svg';
import { ReactComponent as RocketSVG } from 'assets/images/home/rocket.svg';
import { ReactComponent as SwapSVG } from 'assets/images/home/swap.svg';
import { ModalWrapper, StyledModal } from 'pages/Home/mintNFT/styled';
import styled from 'styled-components';
import MintNFTOperateCard from './MintNFTOperateCard';
import { observer } from 'mobx-react';
// import MintNFTCard from './MintNFTCard';
import user from 'stores/user';
import { getOnePieceServerApi } from 'gql-ops';
import { Status } from './config';
import { useChainModal } from '@rainbow-me/rainbowkit';
import { useAccount } from 'wagmi';
import { SupportChainIDs } from 'constant';
import Mission from './Mission';
import MissionChain from './MissionChain';
import DAppIcon from 'components/Icons/DApps';
import { AutoColumn } from 'components/Column';

export interface TaskConfig {
    id: number;
    subTitle?: string;
    title: string;
    description?: React.ReactNode;
    icon: React.ReactNode;
    points?: number;
    link: string;
}

const StyledModalWithCustomClose = styled(StyledModal)`
    .closeIcon {
        top: 105px;
        right: 45px;
        left: auto;
        ${({ theme }) => theme.mediaWidth.upToSmall`
            top: 8rem;
            left: 2rem;
            right: unset;
        `}

        &:hover {
            opacity: 0.8;
        }
    }
`;

const StyledBridgeSVG = styled(BridgeSVG)`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    color: #f7931a;
`;

const StyledGoatupSVG = styled(GoatupSVG)`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    color: #f7931a;
`;

const StyledSatoshiSVG = styled(SatoshiSVG)`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    color: #f7931a;
`;

const StyledRocketSVG = styled(RocketSVG)`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    color: #f7931a;
`;

const StyledSwapSVG = styled(SwapSVG)`
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    color: #f7931a;
`;

const WhiteLink = styled.a`
    color: #fff;
    text-decoration: none;
    transition: color 0.2s;
    &:hover {
        color: #f7931a;
        text-decoration: underline;
    }
`;

const MissionCenter = observer(() => {
    const [currentMission, setCurrentMission] = useState<UserMission | null>(null);
    const [isOpen, setIsOpen] = useState(false);
    const [lockMint, setLockMint] = useState(true);
    const { openChainModal } = useChainModal();
    const { chainId } = useAccount();

    const onChange = useCallback((mission?: UserMission) => {
        if (!mission) {
            missionStore.fetchMissions();
            return;
        }
        missionStore.updateMission(mission);
        missionStore.fetchMissions().then(() => {
            const updatedMission = missionStore.missions.find((m) => m.id === mission.id);
            if (updatedMission) {
                setCurrentMission(updatedMission);
            }
        });
    }, []);

    const handleMissionOperation = async (mission: UserMission) => {
        if (mission.status === Status.NotStart) {
            await getOnePieceServerApi().startMission({
                address: user.address,
                missionId: Number(mission.id),
            });
            missionStore.fetchMissions();
        }
        setCurrentMission(missionStore.missions.find((m) => m.id === mission.id) || null);
        setIsOpen(true);
        setLockMint(true);
    };

    useEffect(() => {
        if (currentMission && chainId && SupportChainIDs.indexOf(chainId) >= 0 && !lockMint) {
            handleMissionOperation(currentMission);
        }
    }, [chainId, currentMission, lockMint]);

    // const clickMint = async (mission: UserMission) => {
    //     if (chainId && SupportChainIDs.indexOf(chainId) < 0 && openChainModal) {
    //         openChainModal();
    //         setLockMint(false);
    //         setCurrentMission(mission);
    //         return;
    //     }
    //     handleMissionOperation(mission);
    // };

    const TASKS: TaskConfig[] = [
        // {
        //     id: 8,
        //     title: 'Scoremilk',
        //     subTitle: 'Points updated every 24 hours',
        //     icon: <DAppIcon dAppName="Scoremilk" />,
        //     description:
        //         'Play Scoremilk games to earn more points! Each game participation rewards 30 Points, with no daily limit.\nPoints updated every 24 hours',
        //     link: 'https://www.scoremilk.com/games',
        //     points: 30,
        // },
        // {
        //     id: 1,
        //     title: 'GOATswap',
        //     icon: <DAppIcon dAppName="Goatswap" />,
        //     description:
        //         'Use GoatSwap to perform a swap between any two tokens (excluding BTC/WGBTC and GOLA trading pairs)',
        //     points: 100,
        //     link: 'https://goatswap.fi/',
        // },
        // {
        //     id: 3,
        //     title: 'GoatRocket',
        //     description: 'Participate in the GOAT Rocket game and win BTC rewards. ',
        //     points: 300,
        //     icon: <StyledRocketSVG />,
        //     link: 'https://goatrocket.io',
        // },
        {
            id: 4,
            title: 'Bridge',
            icon: <StyledBridgeSVG />,
            description: (
                <p>
                    Bridge BTC, BTCB, GOATED, DOGEB to GOAT Network. Bridging higher amounts earns more Points. More
                    details:{' '}
                    <WhiteLink href="https://docs.goat.network/users/onepiece">
                        https://docs.goat.network/users/onepiece
                    </WhiteLink>
                </p>
            ),
            link: 'https://bridge.goat.network',
        },
        {
            id: 10,
            title: 'GOATUP',
            icon: <StyledGoatupSVG />,
            description: (
                <p>
                    GOAT’s first native perpetuals. Trade with BTC as collateral. <br />
                    Earn Points from TVL (liquidity), trading volume, and realized net profit.
                </p>
            ),
            link: 'https://dapp.goatup.io/',
        },
        {
            id: 2,
            title: 'OKU',
            description: 'Trade $GOATED on OKU, earn 2x points.',
            icon: <DAppIcon dAppName="Oku" />,
            link: 'https://oku.trade/swap?inputChain=goat&inToken=0x3022b87ac063DE95b1570F46f5e470F8B53112D8&outToken=0xbC10000000000000000000000000000000000001',
        },
        // {
        //     id: 5,
        //     title: 'Satoshi',
        //     icon: <StyledSatoshiSVG />,
        //     points: 70,
        //     description: 'Interact with the Satoshi GOAT game ',
        //     link: 'https://www.satoshigoat.xyz/',
        // },
        // {
        //     id: 6,
        //     title: 'Avalon',
        //     icon: <DAppIcon dAppName="Avalon" />,
        //     description:
        //         'Avalon Lending/Borrowing activity.\n✅Hold LST assets to get rewards.\n⏱️Hold longer = earn more points',
        //     link: 'https://lend.avalonfinance.xyz/?marketName=proto_goat_v3',
        //     points: 2.5,
        // },
        // {
        //     id: 7,
        //     title: 'Stable Jack',
        //     icon: <DAppIcon dAppName="Stablejack" />,
        //     description:
        //         'Restake on Stable Jack to Earn Points\nStake your artBTC to get p-artBTC or y-artBTC.\nThe longer you restake, the more points you earn!',
        //     link: 'https://app.stablejack.xyz/',
        //     points: 2.5,
        // },
        // {
        //     id: 6,
        //     title: 'Stable Jack',
        //     description: 'Interact with the Satoshi GOAT game ',
        //     link: 'https://app.stablejack.xyz/',
        // },
        // {
        //     id: 7,
        //     title: 'Avalon',
        //     link: 'https://lend.avalonfinance.xyz/reserve-overview/?underlyingAsset=0xbc10000000000000000000000000000000000000&marketName=proto_goat_v3',
        // },
        // {
        //     id: 8,
        //     title: 'Pell Network',
        //     description: 'Re-Stake BTC and',
        //     link: 'https://app.pell.network/restake',
        // },
        // {
        //     id: 9,
        //     title: 'Avalon',
        //     description:
        //         'Stake nETH, esBTC and uBTC to earn rewards. nETH: esBTC: uBTC: https://esbtc.exsat.network/https://app.unirouter.io/uBTC',
        //     link: 'https://app.sumer.money/?chain=2345',
        // },
    ];

    return (
        <MissionCenterContainer id="missionCenter">
            {/* Daily Social Task Section */}
            {missionStore.missions.length ? (
                <div id="dailySocialTask">
                    <RowBetween>
                        <TYPE.desc fontSize="24px" marginBottom={'40px'}>
                            Daily Social Task
                        </TYPE.desc>
                        <TYPE.desc fontSize="16px" color="#F7931A" fontWeight={700}>
                            Points updated every 60 mins
                        </TYPE.desc>
                    </RowBetween>
                    <Grid col={3}>
                        {missionStore.missions
                            .filter((mission: UserMission) => mission.type !== 'FreeMintNFTPiece')
                            .map((mission: UserMission) => (
                                <Mission key={mission.id} mission={mission} onChange={onChange} />
                            ))}
                    </Grid>
                    <TYPE.desc fontSize="14px" style={{ textAlign: 'right', marginTop: '40px', marginBottom: '40px' }}>
                        Due to X platform API limitations, verification may take longer during peak times. Please try
                        again after 15 minutes.
                    </TYPE.desc>
                </div>
            ) : null}

            {/* On-chain Task Center Section */}
            <div id="onChainTaskCenter">
                <AutoColumn>
                    <TYPE.desc fontSize="24px" fontWeight={700}>
                        Top explores
                    </TYPE.desc>
                    <TYPE.desc fontSize="12px" color="#F7931A" marginBottom="10px">
                        Explore DApps, earn points, and power up for Lucky Draw Phase 2!
                    </TYPE.desc>
                </AutoColumn>

                <Grid col={3}>
                    {TASKS.map((task) => (
                        <MissionChain key={task.id} task={task} />
                    ))}
                </Grid>
            </div>

            <StyledModalWithCustomClose
                isOpen={isOpen}
                onClose={() => {
                    setIsOpen(false);
                }}
                closeIcon={<CloseSVG />}
                contentStyle={{
                    background: 'transparent',
                    maxHeight: 'unset',
                    overflow: 'unset',
                }}
                shadowProps={{
                    top: 200,
                    left: -160,
                    right: -160,
                    bottom: 50,
                    blur: 50,
                }}
            >
                <ModalWrapper>
                    <TYPE.main
                        fontSize={28}
                        mobileFz={28}
                        fontWeight={600}
                        width="360px"
                        textAlign="center"
                        marginBottom="20px"
                    >
                        Mint GOAT NFT Piece
                    </TYPE.main>
                    <MintNFTOperateCard mission={currentMission} onChange={onChange} />
                </ModalWrapper>
            </StyledModalWithCustomClose>
        </MissionCenterContainer>
    );
});

export default MissionCenter;
